

































































































































































import { Component, Vue } from 'vue-property-decorator';
import { SheetModule } from '@/store/modules/sheet';
import { getSheetConfig } from '@/apis/sheetConfig';
import { getRecordList, searchFilterList, getViewGroup } from '@/apis/sheet';
import search from '@/components/vant-search/index.vue';
import cell from './cell.vue';
import { Toast } from 'vant';
@Component({
	name: 'Summary',
	components: {
		cell,
		search,
	},
})
export default class extends Vue {
	public viewList: any[] = [];
	public tableData: any[] = [];
	public filesList: any[] = [];
	public fieldsObj: any = {};
	private searchVal = '';
	private showFilterPopup = false;
	private titleField: any = {};
	private loading = false;
	private finished = false;
	private mobileFields = [] as any[];
	private filter: any = ''; // 是否有筛选条件
	private page = { pageNumber: 0, pageSize: 20, total: 0 };
	private filterData = {
		// 公共条件
		common: [],
		// 我的筛选
		my: [],
	};
	private cacheFilter = {};
	private activeName = '';
	private isChartPage = false; // 视图不可查看
	private buttonDisabled = false;
	private filterObj: any = {
		id: '',
		useScope: 1,
		filterName: '',
	};
	private activeIndex = 1;
	private oldActiveIndex = 1;
	private get worksheetAuthority() {
		return SheetModule.worksheetAuthority || {};
	}
	private clear() {
		this.searchVal = '';
		this.search();
	}
	private search() {
		this.tableData = [];
		this.page = { pageNumber: 0, pageSize: 20, total: 0 };
		this.finished = true;
		this.getRecord(true, null);
	}
	private clickViewGroup(index) {
		let current = this.viewList[index];
		this.activeIndex = index;
		this.isChartPage = this.buttonDisabled = false;
		// 如果打开是视图 则不支持查看
		if (current.viewType === 2) {
			this.$toast.fail('暂不支持，请用PC浏览器查看');
			this.isChartPage = true;
			this.$nextTick(() => {
				this.activeIndex = this.oldActiveIndex;
			});
			return;
		}
		if (current.componentType === 'group') {
			this.clickView(current.children[0]);
		} else {
			this.clickView(current);
		}
		this.oldActiveIndex = this.activeIndex;
	}
	private clickView(one) {
		this.activeName = one.id;
		this.$router.push({
			path:
				'/' +
				this.$route.params.applicationId +
				'/' +
				this.$route.params.worksheetId +
				'/sheet/' +
				one.id,
		});
		// this.closeFliterTag()
	}
	private beforeRouteUpdate(to, from, next) {
		this.activeName = to.params.viewId;
		this.searchVal = '';
		this.filter = '';
		this.closeFliterTag();
		next();
	}
	private handleResetData() {
		this.filterObj = {
			id: '',
			useScope: 1,
			filterName: '',
		};
		this.tableData = [];
		this.page = { pageNumber: 0, pageSize: 20, total: 0 };
		this.finished = true;
	}
	private closeFliterTag() {
		this.handleResetData();
		if (!this.isChartPage) {
			this.getRecord(true, null);
		}
	}
	private filterSearch(obj: any) {
		let { id, useScope, filterName } = obj;
		this.filterObj = {
			id,
			useScope,
			filterName,
		};
		this.showFilterPopup = false;
		this.tableData = [];
		this.page = { pageNumber: 0, pageSize: 20, total: 0 };
		this.finished = true;
		this.getRecord(true, null);
	}
	private quickSearch(val) {
		this.filter = val;
		const pageNum = 1;
		let obj;
		if (!val) {
			obj = {
				worksheetId: this.$route.params.worksheetId,
				viewId: this.activeName,
				page: {
					pageNumber: pageNum,
					pageSize: this.page.pageSize,
				},
			};
		} else {
			obj = {
				filters: val,
				worksheetId: this.$route.params.worksheetId,
				viewId: this.activeName,
				page: {
					pageNumber: pageNum,
					pageSize: this.page.pageSize,
				},
			};
		}

		this.finished = true;
		this.getRecordList(obj, pageNum, true);
	}
	private onFilterClick() {
		this.showFilterPopup = true;
	}
	private async getFilterList() {
		let res = await searchFilterList(this.$route.params.worksheetId);
		if (res.success) {
			let common: any = [];
			let my: any = [];
			res.data.forEach((item) => {
				if (item.useScope === 1) {
					my.push(item);
				} else {
					common.push(item);
				}
			});
			this.filterData.common = common;
			this.filterData.my = my;
		}
	}
	private handleRecord(item) {
		let { applicationId, worksheetId, viewId } = this.$route.params;
		this.$router.push(`/${applicationId}/${worksheetId}/sheet/${viewId}/${item.id}`);
	}
	// 获取第一个视图
	private getFirstView(viewGroup) {
		let viewId = '';
		viewGroup.find((item) => {
			if (item.componentType === 'view') {
				viewId = item.id;
				this.setChartState(item);
				return true;
			} else {
				viewId = this.getFirstView(item.children);
				return true;
			}
		});
		return viewId;
	}
	// 如果打开是视图 则不支持查看
	private setChartState(sheet) {
		this.buttonDisabled = false;
		if (sheet.viewType === 2) {
			this.$toast.fail('暂不支持，请用PC浏览器查看');
			this.isChartPage = true;
			this.buttonDisabled = true;
		}
	}
	private getActiveIndexByViewId(viewId, viewGroup) {
		return viewGroup.findIndex((item) => {
			if (item.componentType === 'group') {
				return item.children.find((one) => one.id === viewId);
			} else if (item.id === viewId) {
				this.setChartState(item);
				return true;
			}
		});
	}
	// 获取工作表字段视图
	private async getSheetConfig() {
		this.loading = true;
		const res = await getSheetConfig({
			worksheetId: this.$route.params.worksheetId,
			queryFieldType: 1,
			isQueryView: true,
			isNeedAuthority: true,
		});
		const resViewGroup = await getViewGroup(this.$route.params.worksheetId);
		this.loading = false;
		if (res.success && resViewGroup.success) {
			SheetModule.SET_SHEET_FIELDLIST(res.data);
			this.fieldsObj = {};
			this.filesList = res.data.fields || [];
			this.filesList.map((item) => {
				this.fieldsObj[item.businessId] = item;
			});
			// 标题配置
			// this.titleField = res.data.titleField || ''
			this.titleField = this.fieldsObj[res.data.titleField || ''] || {};
			// 视图
			this.viewList = resViewGroup.data.viewComponents || [];
			let viewId = this.$route.params.viewId;
			let { applicationId } = this.$route.params;
			if (!viewId) {
				// 默认展示第一个
				viewId = this.getFirstView(this.viewList);
				this.activeIndex = 0;
			} else {
				this.activeIndex = this.getActiveIndexByViewId(viewId, this.viewList);
			}

			this.oldActiveIndex = this.activeIndex;
			this.activeName = viewId;
			if (!this.$route.params.viewId) {
				this.$router.replace(
					`/${this.$route.params.applicationId}/${this.$route.params.worksheetId}/sheet/${viewId}`
				);
				this.$nextTick(() => {
					if (!this.isChartPage) {
						this.getRecord(true, viewId);
					}
				});
			} else {
				this.$nextTick(() => {
					if (!this.isChartPage) {
						this.getRecord(true, null);
					}
				});
			}
		}
	}
	private addRecord() {
		let { applicationId, worksheetId, viewId } = this.$route.params;
		this.$router.push(`/${applicationId}/${worksheetId}/sheet/${viewId}/addRecord`);
	}
	private onLoad() {
		this.getRecord(false, null);
	}
	private async getRecord(isStart, viewId) {
		const pageNum = this.page.pageNumber + 1;
		let obj: any = {
			// filterId: this.filterObj.id,
			// titleFieldQueryValue: this.searchVal,
			worksheetId: this.$route.params.worksheetId,
			viewId: this.activeName || viewId,
			page: {
				pageNumber: pageNum,
				pageSize: this.page.pageSize,
			},
		};
		// 判断是否有筛选条件
		if (this.filter) {
			obj.filters = this.filter;
		}
		this.getRecordList(obj, pageNum, isStart);
	}
	private async getRecordList(obj, pageNum, isStart) {
		let res = await getRecordList(obj);
		if (res.success) {
			this.loading = false;
			this.page.pageNumber = pageNum;
			this.page.total = res.data.page.total;
			let { records, mobileListFields } = res.data;
			this.mobileFields = mobileListFields || [];
			(records || []).forEach((item) => {
				if (item.lockFieldAuthority) {
					item.lockFieldAuthority.forEach((one) => {
						if (one.authority === 'hidden' && item[one.businessId]) {
							item[one.businessId] = '';
						}
					});
				}
			});
			if (isStart) {
				this.tableData = records || [];
			} else {
				this.tableData = this.tableData.concat(records || []);
			}
			this.finished = this.tableData.length >= this.page.total;
		} else {
			this.loading = false;
		}
	}
	private mounted() {
		this.getSheetConfig();
		this.getFilterList();
	}
}
